import { Anchor, TypographyStylesProvider } from '@mantine/core';
import { memo } from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import s from './MarkdownContent.module.scss';

type MarkdownContentProps = {
  content: string;
};

const markdownComponents: Components = {
  a: ({ href, children }) => (
    <Anchor href={href} target='_blank' rel='noopener noreferrer' size='sm'>
      {children}
    </Anchor>
  ),
};

export const MarkdownContent = memo(({ content }: MarkdownContentProps) => (
  <TypographyStylesProvider>
    <div className={s.root}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={markdownComponents}
      >
        {content}
      </ReactMarkdown>
    </div>
  </TypographyStylesProvider>
));

MarkdownContent.displayName = 'MarkdownContent';
